<template>
  

  <NavComponents />
  
  <div class="container">
    <div class="header">
        <el-row :gutter="20">
            <el-col :span="14">
              <el-breadcrumb :separator-icon="ArrowRight">
                <el-breadcrumb-item>首页</el-breadcrumb-item>
                <el-breadcrumb-item>课程中心</el-breadcrumb-item>
                <el-breadcrumb-item>{{ course.courseName }}</el-breadcrumb-item>
              </el-breadcrumb>
                <img :src="course.courseImg" class="courseImg">
            </el-col>
            <el-col :span="10">
              <br><br>
                <span class="publicCourse" v-if="course.isPublic == 0">公开课</span>
                <span class="privateCourse" v-if="course.isPublic == 1">私有课</span>
                <span class="font_1">{{ course.courseName }}</span>
                <br>
                <div class="font_2">开课时间：{{ formatDate(course.createTime) }}</div>
                <div class="font_2" v-if="course.teacher">
                  主讲人：
                  <img :src="course.teacher.avatar" class="teacherImg">
                  {{ course.teacher.nickName }}
                </div>
                <div class="font_2">
                  已有 {{ course && course.headCount }} 人参加
                </div>
                <div>
                  <el-button type="success" class="courseBtn" v-if="!hasJoined" @click="joinCourse(course.isPublic)" plain>加入课程</el-button>
                  <el-button type="primary" class="courseBtn" v-if="hasJoined" plain>
                    <router-link class="dropdown-item" :to="{ name: 'learnCourse', params:{courseId: courseId} }">进入课程</router-link>
                  </el-button>
                </div>
            </el-col>
        </el-row>
    </div>

    <div >
        <el-row :gutter="20">
            <el-col :span="16" class="footer">
              <div class="font_3">
                <el-icon><DataAnalysis /></el-icon> 课程概述
              </div>
              <div class="font_2">
                <p style="white-space: pre-line;" v-html="course.describes"></p>
                
              </div>

              
            </el-col>
            <el-col :span="6" class="footer2">
              <div class="font_3">
                <el-icon><Reading /></el-icon> 主讲课程
              </div>
              <div v-for="c in otherCourse" :key="c.courseId" class="otherDiv" @click="hrefCourse(c.courseId);"> 
                  <el-row :gutter="20">
                    <el-col :span="14">
                      <img :src="c.courseImg" class="otherCourseImg">
                    </el-col>
                    <el-col :span="8">
                      <div class="font_4" :title="c.courseName">{{ c.courseName.substr(0, 10) }}</div>
                      <div class="font_4">{{ c.headCount }} 人参加</div>
                    </el-col>
                  </el-row>
                    
                </div>
            </el-col>
        </el-row>
    </div>
    
  </div>
  <NavFooter/>
</template>

<script setup>
import NavComponents from "@/components/nav/NavComponents.vue";
import NavFooter from '@/components/nav/NavFooter.vue'
import { ref, onMounted } from "vue";
import $ from 'jquery'
import { ElMessage, ElMessageBox } from 'element-plus'


import { useRoute } from "vue-router";

const Route = useRoute(); //获取到值

let courseId = ref();
const course = ref([]);
const otherCourse = ref([]);
const hasJoined = ref(false);

onMounted(() => {
  courseId.value = Route.params.courseId;
  pullCourse(courseId.value);
  hasJoinedCourse();
  setTimeout(() => {
    pullTeacherCourse();
  }, 500);  
});


const pullCourse = (id) => {
    $.ajax({
    url: "http://124.222.105.205:5000/get/api/course/getCourseById",
    data: {
        courseId: id
    },
    type: "post",
    success(resp) {
      course.value = resp.data;

      if (resp.code != "200") {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }
    },
    error() {
        ElMessage({
          type: "error",
          message: "获取课程失败",
        });
    },
  });
}

const hasJoinedCourse = () => {
    const token = localStorage.getItem("token");
    $.ajax({
      url: "http://124.222.105.205:5000/api/course/hasJoined",
      data: {
        courseId: courseId.value,
      },
      headers: {
      Authorization: "Bearer " + token,
    },
      type: "post",
      success(resp) {
        if (resp.code == "200") hasJoined.value = true;
        else hasJoined.value = false;
        console.log(resp.code);
      },
      error() {
        hasJoined.value = false;
      },
    });
  };

const pullTeacherCourse = () => {
    $.ajax({
    url: "http://124.222.105.205:5000/get/api/course/pullTeacherCourse",
    type: "post",
    data: {
      id: course.value.teacher.id
    },
    success(resp) {
      otherCourse.value = resp.data;

      if (resp.code != "200") {
        ElMessage({
          type: "error",
          message: resp.msg,
        });
      }
    },
    error() {
        ElMessage({
          type: "error",
          message: "获取其他课程失败",
        });
    },
  });
}

const hrefCourse = (id) => {
  const a = document.createElement('a');
  a.href = `/CourseDetail/${id}`; // 假设课程详情页面的路由是/course/:courseId
  a.target = '_blank'; // 在新页面中打开
  a.click(); // 触发点击事件
}

const formatDate = (dateTime) => {
      // 将传入的日期时间字符串转换为Date对象
      const date = new Date(dateTime);
      // 使用Date对象的方法获取年月日
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1，并且补0
      const day = String(date.getDate()).padStart(2, '0'); // 补0
      // 返回格式化后的日期字符串，不包含时分秒
      return `${year}-${month}-${day}`;
    }

const joinCourse = (isPublic) => {
  const token = localStorage.getItem("token");
  if (isPublic == 0) {
    ElMessageBox.confirm("是否加入该课程?", "加入课程", {
    confirmButtonText: "确认",
    cancelButtonText: "取消",
    type: "warning",
  })
    .then(() => {
      const token = localStorage.getItem("token");
        $.ajax({
          url: "http://124.222.105.205:5000/api/course/addCourse",
          data: {
            addCode: "",
            isPublic: 0,
            courseId: courseId.value
          },
          headers: {
          Authorization: "Bearer " + token,
        },
          type: "post",
          success(resp) {
            if (resp.code == "200") {
              ElMessage({
                type: "success",
                message: resp.msg,
              });
              pullCourse(courseId.value);
              hasJoinedCourse();
            } else {
              ElMessage({
                type: "error",
                message: resp.msg,
              });
              return ;
            }
          },
          error() {
            ElMessage({
                type: "error",
                message: "加入课程失败",
              });
          },
        });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消加入",
      });
    });
  } else if(isPublic == 1){
      ElMessageBox.prompt('是否加入该课程,请输入加课码！', '加入课程', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
    })
      .then(({value }) => {
        if (value == null) {
          ElMessage({
            type: 'error',
            message: "加课码不能为空！"
          })
          return ;
        }
        $.ajax({
          url: "http://124.222.105.205:5000/api/course/addCourse",
          data: {
            addCode: value,
            isPublic: 1,
            courseId: courseId.value
          },
          headers: {
          Authorization: "Bearer " + token,
        },
          type: "post",
          success(resp) {
            if (resp.code == "200") {
              ElMessage({
                type: "success",
                message: resp.msg,
              });
              pullCourse(courseId.value);
              hasJoinedCourse();
            } else {
              ElMessage({
                type: "error",
                message: resp.msg,
              });
            }
          },
          error() {
            ElMessage({
                type: "error",
                message: "加入课程失败",
              });
          },
        });
    })
    .catch(() => {
      ElMessage({
        type: "info",
        message: "取消加入",
      });
        
      })
  }
} 
</script>

<style scoped>
.courseImg {
    width: 650px;
    border-radius: 10px;
    margin-top: 30px;
}

.header {
    background-color: rgb(248, 247, 246);
    padding: 60px 20px;
    border-radius: 20px;
}

.otherDiv {
  margin: 5px 0px;
}

.otherDiv:hover{
  cursor: pointer;
}


.otherCourseImg {
  width: 100%;
  border: 5px;
}

.publicCourse {
    width: auto; /* Adjust width based on content */
    padding: 5px; /* Add padding for better appearance */
    font-size: 15px; /* Decrease font size */
    color: rgba(243, 160, 35, 0.97); /* Set text color */
    border-radius: 5px; /* Add border radius for rounded corners */
    border: 1.5px solid rgba(243, 160, 35, 0.97);
}

.privateCourse {
    width: auto; /* Adjust width based on content */
    padding: 5px; /* Add padding for better appearance */
    font-size: 15px; /* Decrease font size */
    color: rgba(165, 66, 196, 0.97);  /* Set text color */
    border-radius: 5%; /* Add border radius for rounded corners */
    border: 1.5px solid rgba(165, 66, 196, 0.97);
}

.font_1 {
    font-weight: bolder;
    font-size: 30px;
    margin: 5px;
}

.font_2 {
    margin: 25px 0px;
    color: rgb(88, 88, 88);
}

.font_3 {
  font-size: 20px;
  font-weight: 500;

}
.font_4 {
    color: rgb(88, 88, 88);
}

.footer {
  background-color: rgb(248, 247, 246);
    padding: 40px 20px;
    border-radius: 20px;
    margin:50px  20px;
}

.footer2 {
  background-color: rgb(248, 247, 246);
    padding: 40px 20px;
    border-radius: 20px;
    margin:50px  20px;
    height: 100%;
}

.teacherImg {
  width: 40px;
  border-radius: 50px;
}

.courseBtn {
  width: 300px;
  font-size: 30px;
  font-weight: bold;
  height: 80px;
  letter-spacing: 10px;
  border-radius: 20px;
}
</style>